import { render } from "./BlogDetailsRightSidebar.vue?vue&type=template&id=15f8d506"
import script from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js"
export * from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__